class SliderComponentAutoplay extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = true;
    this.prevButton.addEventListener('click', this.onButtonClicks.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClicks.bind(this));

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlays();
  }

  update() {
    super.update();
    this.prevButton.removeAttribute('disabled');
  }

  setAutoPlays() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandlings.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandlings.bind(this));
    this.addEventListener('focusin', this.focusInHandlings.bind(this));
    this.addEventListener('focusout', this.focusOutHandlings.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlaysToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.plays();
    }
  }

  onButtonClicks(event) {
    //super.onButtonClick(event);
    //if (this.enableSliderLooping || this.slider.getAttribute('data-autoplay')) {
      this.wasClicked = true;

      const isFirstSlide = this.currentPage === 1;
      // const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
      // const isLastSlide = this.currentPage === this.sliderItemsToShow.length - 2;
      const desktopColumns = this.slider.getAttribute('data-desktop-columns');
      const mobileColumns = this.slider.getAttribute('data-mobile-columns');
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length - 2;
      var sliderFirstItemNode = this.slider.querySelector('.slider__slide');
      const step = event.currentTarget.dataset.step || 1;

      if (isFirstSlide && event.currentTarget.name === 'previous') {
        // this.slideScrollPosition = this.slider.scrollLeft - step * this.sliderItemOffset;
        // this.slideScrollPosition = this.slider.scrollLeft + step * this.sliderItemsToShow.length;
        this.slideScrollPosition = this.slider.scrollLeft + sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        this.slideScrollPosition = 0;
        //this.slider.scrollLeft + step * this.sliderItemOffset;
      }

      this.setSlidePositions(this.slideScrollPosition);
    //}
  }

  autoPlaysToggle() {
    this.togglePlayButtonStates(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pauses() : this.plays();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandlings(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.plays();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.plays();
    }
  }

  focusInHandlings(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.plays();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pauses();
      }
    }
  }

  plays() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplays);
    this.autoplays = setInterval(this.autoRotatesSlides.bind(this), this.autoplaySpeed);
  }

  pauses() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplays);
  }

  togglePlayButtonStates(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotatesSlides() {
    // const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
    //const slideScrollPosition = this.currentPage === this.sliderItems.length - 2 ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    const desktopColumns = this.slider.getAttribute('data-desktop-columns');
    const mobileColumns = this.slider.getAttribute('data-mobile-columns');
    const slideScrollPosition = this.currentPage === this.sliderItems.length - 2 ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePositions(slideScrollPosition);
  }

  setSlidePositions(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, 500);
  }
}

customElements.define('slider-component-autoplay', SliderComponentAutoplay);